<div class="flex flex-column w-full">

  <div class="topbar flex align-items-center justify-content-between w-full gap-3">
    @if (showClientLogo()) {
      <div class="topbar-brand flex align-items-center flex-shrink-0">
        @if (showCompanyLogoImage()) {
          <img
            [src]="companyLogo()!"
            alt="Logo de la empresa"
            class="topbar-brand-logo"
            (error)="onCompanyLogoError()"
          />
        } @else {
          <div class="topbar-brand-placeholder flex align-items-center justify-content-center border-round">
            <i class="pi pi-building text-lg"></i>
          </div>
        }
      </div>
    } @else {
      <div class="flex-shrink-0"></div>
    }

    <div class="flex align-items-center flex-shrink-0 gap-1">
      <div class="hidden md:block">
        @if (showDoSearch()) {
          <p-iconfield>
            <input
              pInputText
              placeholder="Búsqueda DO"
              class="bg-transparent border-round-3xl"
              pSize="small"
              [value]="doQuery()"
              [disabled]="searchingDo()"
              (input)="onDoQueryInput($any($event.target).value)"
              (keydown.enter)="onDoSearch()"
            />
            <p-inputicon
              class="pi cursor-pointer"
              [class.pi-search]="!searchingDo()"
              [class.pi-spin]="searchingDo()"
              [class.pi-spinner]="searchingDo()"
              (click)="onDoSearch()"
            />
          </p-iconfield>
        }
      </div>

      <p-popover #notifPopover [dismissable]="true">
        <div class="w-17rem max-w-22rem">
          <div class="font-bold text-sm text-gray-900 pb-2 mb-2 border-bottom-1 border-200">Notificaciones</div>
          <ul class="list-none m-0 p-0 flex flex-column">
            @for (item of notifications; track item.id; let last = $last) {
              <li
                class="flex flex-column gap-1 pt-2"
                [class.pb-2]="!last"
                [class.pb-0]="last"
                [class.border-bottom-1]="!last"
                [class.border-100]="!last"
              >
                <span class="text-sm text-gray-900 line-height-3">{{ item.title }}</span>
                <span class="text-xs text-color-secondary">{{ item.time }}</span>
              </li>
            }
          </ul>
        </div>
      </p-popover>

      <div class="flex align-items-center gap-2 flex-shrink-0">
        <div class="flex flex-column gap-0 min-w-0">
          <span class="font-bold text-sm text-gray-900 white-space-nowrap">{{ userName() }}</span>
          <span class="text-xs text-color-secondary white-space-nowrap">{{ userRole() }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (companyCtx.isInContext()) {
    <div class="company-banner flex align-items-center justify-content-between gap-3 px-3 py-2 border-round-lg">
      <div class="flex align-items-center gap-3">
        <div class="company-banner__icon flex align-items-center justify-content-center border-round-lg flex-shrink-0">
          <i class="pi pi-eye text-sm"></i>
        </div>
        <div class="flex flex-column gap-1">
          <span class="company-banner__title text-sm font-bold line-height-1">Usted se encuentra en la vista administrador</span>
          <span class="company-banner__subtitle text-xs line-height-1">Usted podrá gestionar la información de la empresa: <strong>{{ companyCtx.companyName() }}</strong></span>
        </div>
      </div>
      <button class="company-banner__exit flex align-items-center gap-2 flex-shrink-0" (click)="exitCompany()">
        <span class="text-sm">Cerrar vista administrador</span>
        <i class="pi pi-times text-xs"></i>
      </button>
    </div>
  }

</div>
